
import { defineComponent } from 'vue';

import store from "@/store";

import Editor from "@/components/Editor.vue";
import Lesson from "@/components/Lesson.vue";
import Output from "@/components/Output.vue";
import Navigation from "@/components/Navigation.vue";

interface App {
  lesson: Boolean,
  editor: Boolean,
  output: Boolean,
}

export default defineComponent({
  components: {
    Editor,
    Lesson,
    Output,
    Navigation,
  },
  data () {
    return {
      lesson: true,
      editor: true,
      output: false,
    } as App;
  },
  mounted () {
    store.dispatch('open', {
      callback: (key: string) => {
        if (key === 'lesson') {
          this.lesson = !this.lesson;
        } else if (key === 'editor') {
          this.editor = !this.editor;
        } else if (key === 'output') {
          this.output = !this.output;
        }
      }
    });
  }
});
